export interface IPayment {
  id: number
  suscription_id: number
  operation_number: string
  voucher: any
  created_at: string
  status: string
  channel_register?:string | null
  utm_source?:string | null
  utm_medium?:string | null
  utm_campaign?:string | null
}

export enum SolicitudeStatusEnum {
  INGRESADA = 'Ingresada',
  CONFIRMADA = 'Confirmada',
  ANULADA = 'Anulada',
  LIQUIDADA = 'Liquidada',
  PROCESADA = 'Procesada',
}

export enum IPaymentStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  ANNULLED = 'ANNULLED',
}
